import { jobs_helper } from "@/helpers/jobs_helper";
import classes from "./styles.module.scss";
import { seo_jobs_helper } from "@/helpers/seo_jobs_helper";

import Hero2 from "@/components/Hero2";
import { Cookies } from "@/components";

export default function Sitemap({}) {

  const seo_jobs = seo_jobs_helper.fetch();

  return (
    <>
      <div className={classes.sitemap}>
      <Hero2 highlight="jobs sitemap" scroll={false}/>        
        <ul className={classes.jobs}>
          {
            seo_jobs.map( (job, index) => 
            <li key={index} className={classes.job}>
              <a href={"/job-role/" + job.url_slug}>{job.title}</a>
            </li>)
          }
        </ul>
      </div>
      
    </>
  );
}

export async function getStaticProps({}) {
  const all_jobs = jobs_helper.fetch();

  return {
    props: {
      all_jobs
    },
  };
}